import {Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {BugReportErrorContext} from '../../api/models/bug-report-error-context.model';

@Injectable({
  providedIn: 'root'
})
export class ResponseNotificationService {

  static readonly MESSAGE = 0;
  static readonly VALIDATION_ERROR = 1;
  static readonly VALIDATION_WARNING = 2;


  notification: any = new Subject();
  public lastErrorCode: string | null = null;
  public lastErrorContext: BugReportErrorContext | null = null;

  constructor() {
  }

  public emitError(content: string, errorCode: string | null = null, errorContext: BugReportErrorContext | null = null): void {
    this.lastErrorCode = errorCode ?? null;
    this.lastErrorContext = errorContext;
    this.notification.next({
      content: {heading: 'app.error.title', message: content, errorCode: this.lastErrorCode, errorContext},
      type: ResponseNotificationService.VALIDATION_ERROR
    });
  }

  public emitWarning(content): void {
    this.notification.next({
      content: {heading: 'app.warning.title', message: content},
      type: ResponseNotificationService.VALIDATION_WARNING
    });
  }

  public emitMessage(content: string) {
    this.notification.next({
      content: {heading: 'app.success.title', message: content},
      type: ResponseNotificationService.MESSAGE
    });
  }
}
